import React from "react";
import PropTypes from "prop-types";
import "react-dates/initialize";
import momentPropTypes from "react-moment-proptypes";
import moment from "moment";
import omit from "lodash/omit";
import {
  DateRangePicker,
  SingleDatePicker,
  DayPickerRangeController
} from "react-dates";
import styles from "./DatePicker.scss";

class SingleDatePickerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: props.autoFocus,
      date: props.initialDate
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  onDateChange(date) {
    this.setState({ date });
    this.props.selectedDate(date);
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }

  render() {
    const { focused, date } = this.state;
    // autoFocus and initialDate are helper props for the example wrapper but are not
    // props on the SingleDatePicker itself and thus, have to be omitted.
    const props = omit(this.props, ["autoFocus", "initialDate"]);
    const { selectedDate, clearDate, ...rest } = props;

    return (
      <div className={styles.datePicker}>
        <SingleDatePicker
          id="date_input"
          date={clearDate ? "" : date}
          focused={focused}
          readOnly
          onDateChange={this.onDateChange}
          onFocusChange={this.onFocusChange}
          noBorder
          numberOfMonths={1}
          displayFormat={"YYYY-MM-DD"}
          {...rest}
        />
      </div>
    );
  }
}

export default SingleDatePickerWrapper;



// WEBPACK FOOTER //
// ./src/components/common/datePicker/DatePicker.js